export const INSERT_TYPE_BLANK = 'INSERT_TYPE_BLANK';
export const INSERT_TURBO_QUAD_OVAL = 'INSERT_TURBO_QUAD_OVAL';
export const INSERT_TURBO_QUAD_POWER_OVAL = 'INSERT_TURBO_QUAD_POWER_OVAL';
export const INSERT_TURBO_QUAD_2_OVAL_NUBS = 'INSERT_TURBO_QUAD_2_OVAL_NUBS';
export const INSERT_TURBO_QUAD_2_SEMI = 'INSERT_TURBO_QUAD_2_SEMI';
export const INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT = 'INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT';
export const INSERT_TURBO_QUAD_CLASSIC_OVAL = 'INSERT_TURBO_QUAD_CLASSIC_OVAL';
export const INSERT_TURBO_QUAD_SB_POWER_LIFT = 'INSERT_TURBO_QUAD_SB_POWER_LIFT';
export const INSERT_TURBO_QUAD_SB_SEMI = 'INSERT_TURBO_QUAD_SB_SEMI';
export const INSERT_TURBO_MISS_QUAD_OVAL = 'INSERT_TURBO_MISS_QUAD_OVAL';
export const INSERT_TURBO_MISS_QUAD_POWER_OVAL = 'INSERT_TURBO_MISS_QUAD_POWER_OVAL';
export const INSERT_CONTOUR_SUPERSOFT = 'INSERT_CONTOUR_SUPERSOFT';
export const INSERT_CONTOUR_SILICONE = 'INSERT_CONTOUR_SILICONE';
export const INSERT_VISE_POWER_LIFT = 'INSERT_VISE_POWER_LIFT';
export const INSERT_VISE_SEMI = 'INSERT_VISE_SEMI';
export const INSERT_VISE_SEMI_7_8 = 'INSERT_VISE_SEMI_7_8';
export const INSERT_VISE_POWER_OVAL = 'INSERT_VISE_POWER_OVAL';
export const INSERT_VISE_OVAL = 'INSERT_VISE_OVAL';
export const INSERT_VISE_OVAL_7_8 = 'INSERT_VISE_OVAL_7_8';
export const INSERT_VISE_SILICONE = 'INSERT_VISE_SILICONE';
export const INSERT_VISE_GRAPE_NUBS = 'INSERT_VISE_GRAPE_NUBS';
export const INSERT_VISE_POWER_LIFT_7_8 = 'INSERT_VISE_POWER_LIFT_7_8';
export const INSERT_VISE_POWER_OVAL_7_8 = 'INSERT_VISE_POWER_OVAL_7_8';
export const INSERT_ULTIMATE_TLO_OVAL = 'INSERT_ULTIMATE_TLO_OVAL';
export const INSERT_ULTIMATE_TLO_LIFT = 'INSERT_ULTIMATE_TLO_LIFT';
export const INSERT_ULTIMATE_TLO_OVAL_7_8 = 'INSERT_ULTIMATE_TLO_OVAL_7_8';
export const INSERT_ULTIMATE_TLO_LIFT_7_8 = 'INSERT_ULTIMATE_TLO_LIFT_7_8';
export const INSERT_CONTOUR_SEMI_CERISE = 'INSERT_CONTOUR_SEMI_CERISE';
